<template>
  <CRow class="widgets">
    <CCol>
      <ReportingWidget
        :title="{ label: 'Automated Posting', to: { name: 'PostingActivityReport' } }"
        :text="widgetData.posts"
        :locked="!features.automatedPosting && !features.postingService"
        classic-icon="faBuildingCircleCheckClassic"
        duotone-icon="faBuildingCircleCheckDuotone"
        info-text="Amount of ads made with PostEngine within the selected time span."
      />
    </CCol>
    <CCol>
      <ReportingWidget
        :title="{ label: 'Automatic Renewal', to: { name: 'PostingActivityReport' } }"
        :text="widgetData.renews"
        :locked="!features.automaticRenewal"
        classic-icon="faArrowsSpinClassic"
        duotone-icon="faArrowsSpinDuotone"
        info-text="Amount of renewals performed within the selected time span."
      />
    </CCol>
    <CCol>
      <ReportingWidget
        :title="{ label: 'Call Tracking', to: { name: 'PhoneReport' } }"
        :text="widgetData.calls"
        :locked="!features.callTracking"
        classic-icon="faPhoneVolumeClassic"
        duotone-icon="faPhoneVolumeDuotone"
        info-text="Number of calls in the selected time span."
      />
    </CCol>
    <CCol>
      <ReportingWidget
        :title="{ label: 'Email Handling', to: { name: 'EmailReport' } }"
        :text="widgetData.emails"
        :locked="!features.emailHandling"
        classic-icon="faEnvelopeDotClassic"
        duotone-icon="faEnvelopeDotDuotone"
        info-text="Number of emails in the selected time span."
      />
    </CCol>
    <CCol>
      <ReportingWidget
        :title="{ label: 'Website Traffic', to: { name: 'WebsiteTrafficReport' } }"
        :text="widgetData.visits"
        :locked="!features.redirectLinks"
        classic-icon="faLaptopClassic"
        duotone-icon="faLaptopDuotone"
        info-text="Number of unique visitors to your website during the selected time span."
      />
    </CCol>
  </CRow>
</template>

<script>
import { ReportingWidget } from '@/views/reporting/_components'

export default {
  name: 'Widgets',
  components: {
    ReportingWidget
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    features: {
      type: Object,
      required: true
    }
  },
  computed: {
    widgetData () {
      return {
        posts: this.data.events.posts.total > 0 ? `${this.data.events.posts.total} Posts` : null,
        renews: this.data.events.renews.total > 0 ? `${this.data.events.renews.total} Renews` : null,
        calls: this.data.leads.phone.total > 0 ? `${this.data.leads.phone.total} Calls` : null,
        emails: this.data.leads.emails.total > 0 ? `${this.data.leads.emails.total} Emails` : null,
        visits: this.data.leads.redirects.total > 0 ? `${this.data.leads.redirects.total} Visits` : null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .widgets {

  .col {
    padding-right: 10px;
    padding-left: 10px;
  }
}
</style>
